(function () {
  'use strict';

  var copy = {
    en: {timer:'Offer ends in',days:'Days',hours:'Hours',minutes:'Minutes',seconds:'Seconds',hTitle:'Halloween Edit · 10% Off',hCopy:'Applied automatically at checkout. No code needed.',wTitle:'10% Off Your First Order',wCopy:'Use this code on other eligible styles.',cartTitle:'Your available offers',cartCopy:'Halloween styles receive 10% off automatically. First order? Use WELCOME10 on other eligible styles.',cartNote:'Offers cannot be combined on the same item.',button:'Copy code',copied:'Copied',announcement:'🎃 Halloween Edit · 10% Off · Ends October 31'},
    de: {timer:'Aktion endet in',days:'Tage',hours:'Std.',minutes:'Min.',seconds:'Sek.',hTitle:'Halloween-Aktion · 10 % Rabatt',hCopy:'Wird im Checkout automatisch abgezogen. Kein Code nötig.',wTitle:'10 % Rabatt auf deine erste Bestellung',wCopy:'Nutze diesen Code für andere teilnehmende Styles.',cartTitle:'Deine verfügbaren Angebote',cartCopy:'Auf Halloween-Styles werden 10 % automatisch abgezogen. Erste Bestellung? Nutze WELCOME10 für andere teilnehmende Styles.',cartNote:'Rabatte sind für denselben Artikel nicht kombinierbar.',button:'Code kopieren',copied:'Kopiert',announcement:'🎃 Halloween-Aktion · 10 % Rabatt · Endet am 31. Oktober'},
    fr: {timer:'Fin de l’offre dans',days:'Jours',hours:'Heures',minutes:'Min.',seconds:'Sec.',hTitle:'Offre Halloween · -10 %',hCopy:'Remise appliquée automatiquement au paiement. Aucun code requis.',wTitle:'-10 % sur votre première commande',wCopy:'Utilisez ce code sur les autres articles éligibles.',cartTitle:'Vos offres disponibles',cartCopy:'La sélection Halloween bénéficie automatiquement de -10 %. Première commande ? Utilisez WELCOME10 sur les autres articles éligibles.',cartNote:'Les remises ne sont pas cumulables sur un même article.',button:'Copier le code',copied:'Copié',announcement:'🎃 Offre Halloween · 10 % de réduction · Jusqu’au 31 octobre'}
  };

  var config = document.getElementById('yeese-campaign-config');
  var locale = ((config && config.dataset.locale) || document.documentElement.lang || 'en').slice(0,2).toLowerCase();
  var t = copy[locale] || copy.en;

  // Announcement copy is managed by theme settings and Shopify translations.
  function parseDeadline(value) {
    if (!value) return NaN;

    var direct = Date.parse(value);
    if (Number.isFinite(direct)) return direct;

    // Shopify translations can localize a text setting that contains an ISO
    // date. Accept common German/French day-first forms and rebuild ISO 8601.
    var match = value.trim().match(/^(\d{1,2})[.\/-](\d{1,2})[.\/-](\d{4})(?:\s*(?:,|à)?\s*(\d{1,2}):(\d{2})(?::(\d{2}))?\s*(Z|[+-]\d{2}:?\d{2})?)?$/i);
    if (!match) return NaN;

    var day = match[1].padStart(2, '0');
    var month = match[2].padStart(2, '0');
    var year = match[3];
    var hours = (match[4] || '23').padStart(2, '0');
    var minutes = match[5] || '59';
    var seconds = match[6] || '59';
    var zone = match[7] || '';
    if (/^[+-]\d{4}$/.test(zone)) zone = zone.slice(0, 3) + ':' + zone.slice(3);

    return Date.parse(year + '-' + month + '-' + day + 'T' + hours + ':' + minutes + ':' + seconds + zone);
  }

  function setupCountdown(root) {
    var deadline = parseDeadline(root.dataset.deadline);
    if (!Number.isFinite(deadline)) return;
    root.querySelector('[data-countdown-title]').textContent = t.timer;
    [['days',t.days],['hours',t.hours],['minutes',t.minutes],['seconds',t.seconds]].forEach(function (item) {
      root.querySelector('[data-label-' + item[0] + ']').textContent = item[1];
    });
    function update() {
      var left = Math.max(0, deadline - Date.now());
      var seconds = Math.floor(left / 1000);
      var values = {days:Math.floor(seconds/86400),hours:Math.floor(seconds%86400/3600),minutes:Math.floor(seconds%3600/60),seconds:seconds%60};
      Object.keys(values).forEach(function (key) { root.querySelector('[data-' + key + ']').textContent = String(values[key]).padStart(2,'0'); });
      if (!left) root.querySelector('[data-countdown-title]').textContent = root.dataset.expiredText || '';
    }
    update(); window.setInterval(update, 1000);
  }

  function bindCopy(scope) {
    scope.querySelectorAll('[data-copy-code]:not([data-copy-bound])').forEach(function (button) {
      button.dataset.copyBound = 'true'; button.textContent = t.button;
      button.addEventListener('click', function () {
        var code = button.dataset.copyCode;
        var done = function () { button.textContent = t.copied; window.setTimeout(function(){button.textContent=t.button;},1600); };
        if (navigator.clipboard && window.isSecureContext) navigator.clipboard.writeText(code).then(done);
        else { var input=document.createElement('textarea'); input.value=code; document.body.appendChild(input); input.select(); document.execCommand('copy'); input.remove(); done(); }
      });
    });
  }

  function mountProduct() {
    if (document.querySelector('.yeese-promo--product')) return;
    var anchor = document.querySelector('.product-info__price');
    var template = document.getElementById('yeese-product-promo-template');
    if (!anchor || !template) return;
    var node = template.content.firstElementChild.cloneNode(true);
    var halloween = Boolean(config && config.dataset.halloweenProduct === 'true');
    node.querySelector('[data-promo-title]').textContent = halloween ? t.hTitle : t.wTitle;
    node.querySelector('[data-promo-copy]').textContent = halloween ? t.hCopy : t.wCopy;
    if (halloween) node.querySelector('[data-code-row]').remove();
    anchor.insertAdjacentElement('afterend', node); bindCopy(node);
  }

  function mountCart() {
    var drawer = document.querySelector('cart-drawer, .js-cart-drawer');
    if (!drawer || drawer.querySelector('.yeese-promo--cart')) return;
    var anchor = drawer.querySelector('.cart-drawer__footer');
    var template = document.getElementById('yeese-cart-promo-template');
    if (!anchor || !template) return;
    var node = template.content.firstElementChild.cloneNode(true);
    node.querySelector('[data-cart-title]').textContent=t.cartTitle;
    node.querySelector('[data-cart-copy]').textContent=t.cartCopy;
    node.querySelector('[data-cart-note]').textContent=t.cartNote;
    anchor.insertAdjacentElement('beforebegin',node); bindCopy(node);
  }

  function init() {
    
    document.querySelectorAll('[data-yeese-countdown]').forEach(setupCountdown);
    mountProduct(); bindCopy(document);
    new MutationObserver(function(){mountProduct();}).observe(document.body,{childList:true,subtree:true});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',init); else init();
})();
